// Lock-screen caps for manual push copy. The server's limits win when a page has them.
// Titles: 25 or fewer is what she prefers, 30 is the hard cap (tested on her phone 2026-11-01).
export const PUSH_LIMITS = { title: 30, titlePreferred: 25, message: 100 };

// Code points, same as the server, so an emoji counts as one.
export const charCount = (s) => Array.from(String(s || "").trim()).length;

// "is-over" past the cap, "is-long" past the preferred length.
export const countState = (n, max, preferred) =>
  n > max ? "is-over" : preferred && n > preferred ? "is-long" : "";
